// extracted by mini-css-extract-plugin
export default {"wrapper":"fourPlayersIntroduction_wrapper__0nUU3","button":"fourPlayersIntroduction_button__kYexi"};